<template>
  <div class="installation-container tab-body flex-column h-100 mycomputer-container">
    <div class="custom-tab-body-cont px-2 py-3">
      <vue-transmit class="col-12" tag="section" v-bind="options" upload-area-classes="bg-faded" ref="uploader" @success="onSuccess" @error="onError">
        <!-- <b-row>

        </b-row> -->
        <div class="d-flex align-items-center justify-content-center">
          <div class="file-drop-container dz-message" @click="triggerBrowse">
            <upload-icon class="icon-default upload"></upload-icon>
            <div class="file-drop-title">
              Drag & drop here
            </div>
            <div class="file-drop-desc">
              or
              <span class="link">browse</span> for zip file to upload
            </div>
          </div>
        </div>
        <template slot="files" slot-scope="props">
          <div class="col-6">
            <div v-for="(file,index) in props.files" :key="index" :value="file.dataURL">
              <div class="alert-error" v-if="file.errorMessage">
                {{file.errorMessage}}
              </div>
              <div class="file-list">
                <span class="file-name">{{ file.name }}</span>
                <span class="file-size">{{ file.size | prettyBytes}}</span>
                <span class="file-progress">
                  <b-progress v-if="file.upload.progress!=100" :value="file.upload.progress" :max="100"></b-progress>
                  <a @click="toggleFavorite(file,index)" v-else v-b-tooltip.hover title="Add to Favourite">
                    <heart-icon class="icon-default heart" v-bind:class="{filled:file.isFavorite}"></heart-icon>
                  </a>
                </span>
              </div>
              <div v-show="file.showFavorite">
                <input type="text" class="edit-input" :ref="file.id" v-model="file.favName" @keyup.enter="addToFavorite(file,index)">
                <a @click="addToFavorite(file,index)">
                  <tick-icon class="icon-default tick"></tick-icon>
                </a>
              </div>
            </div>
          </div>
        </template>
      </vue-transmit>
    </div>
    <div class="custom-tab-body-footer">
      <div class="d-flex align-items-center flex-row-reverse">
          <b-button variant="primary" @click="install">Install</b-button>
          <b-form-checkbox v-model="activate" class="installoptions">Activate after installation</b-form-checkbox>
          <b-form-checkbox v-model="clearDestination" class="installoptions">Overwrite if {{this.type=='plugins'?'plugin':'theme'}} exist</b-form-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import HeartIcon from '../../assets/heart.svg';
import UploadIcon from '../../assets/upload.svg';
import TickIcon from '../../assets/tick.svg';
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';

export default {
  name: 'mycomputerinstaller',
  props: ['type', 'sites'],
  components: {
    UploadIcon,
    HeartIcon,
    TickIcon
  },
  mixins: [validationMixin],
  validations: {
    sites: {
      required
    }
  },
  data() {
    return {
      clearDestination: false,
      activate: false,
      baseURL: window.appURL + 'uploadScript.php',
      options: {
        acceptedFileTypes: [
          'application/zip',
          'application/x-zip-compressed',
          'application/octet-stream',
          'multipart/x-zip'
        ],
        clickable: false,
        adapterOptions: {
          url: './uploadScript.php',
          withCredentials: true
        }
      }
    };
  },
  methods: {
    triggerBrowse() {
      this.$refs.uploader.triggerBrowseFiles();
    },
    install() {
      console.log(this.$refs.uploader.files);

      let files = this.$refs.uploader.files;
      let selectedItems = [];
      _.each(files, file => {
        if (!file.errorMessage) {
          selectedItems.push(window.serverURL + 'uploads/' + file.remoteURL);
        }
      });
      this.$emit('onInstall', {
        selectedItems: selectedItems,
        type: this.type,
        clearDestination: this.clearDestination,
        activate: this.activate
      });
    },
    addToFavorite(item, index) {
      item.isFavorite = true;
      this.$emit('addFavorite', {
        name: item.favName,
        fileName: item.remoteURL,
        folderPath: 'uploads/',
        type: this.type
      });
      item.showFavorite = false;
      Vue.set(this.$refs.uploader.files, index, item);
    },
    toggleFavorite(item, index) {
      item.showFavorite = true;
      item.isFavorite = true;
      Vue.set(this.$refs.uploader.files, index, item);
    },
    onSuccess(file, response) {
      if (response.error) {
        //let index = _.findIndex(this.refs.uploader.files, { id: file.id });
        file.errorMessage = response.error;
        // if (index > -1) {
        //   Vue.set(this.$refs.uploader.files, index, file);
        // }
        return;
      }
      console.log('onsuccess', file, response);
      file.remoteURL = response.filename;
    },
    onError(file, response) {
      console.log('onerror', file, response);
    }
  },
  filters: {
    json(value) {
      return JSON.stringify(value, null, 2);
    },
    prettyBytes(num) {
      if (typeof num !== 'number' || isNaN(num)) {
        throw new TypeError('Expected a number');
      }

      var exponent;
      var unit;
      var neg = num < 0;
      var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      if (neg) {
        num = -num;
      }

      if (num < 1) {
        return (neg ? '-' : '') + num + ' B';
      }

      exponent = Math.min(
        Math.floor(Math.log(num) / Math.log(1000)),
        units.length - 1
      );
      num = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
      unit = units[exponent];

      return (neg ? '-' : '') + num + ' ' + unit;
    }
  }
};
</script>

<style scoped>
</style>
